export default "__VITE_PUBLIC_ASSET__5bdf3008__"